import { render, staticRenderFns } from "./SubmitNewRecordModal.vue?vue&type=template&id=bd91c170"
import script from "./SubmitNewRecordModal.vue?vue&type=script&lang=ts"
export * from "./SubmitNewRecordModal.vue?vue&type=script&lang=ts"
import style0 from "./SubmitNewRecordModal.vue?vue&type=style&index=0&id=bd91c170&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports